import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-admin-nav-details',
  standalone: true,
  imports: [],
  templateUrl: './admin-nav-details.component.html',
  styleUrl: './admin-nav-details.component.css'
})
export class AdminNavDetailsComponent {

  // properties
  @Input() pageName: string = 'Default message';
  @Input() pageMessage: string = "N/A";

  isEditMode = false;

}
